import produce from 'immer';

import { SET_EXPORT_FORMAT } from './exportConstants';
import { IExportActions, IExportState } from './exportTypes';

export const exportInitialState: IExportState = {
    fileFormat: '',
    tableName: '',
};

const exportReducer = (state: IExportState = exportInitialState, action: IExportActions) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SET_EXPORT_FORMAT:
                draft.fileFormat = action.payload.fileFormat;
                draft.tableName = action.payload.tableName;
                break;
            default:
                break;
        }
    });

export default exportReducer;
